<script lang="ts">
    export let src: string;
    export let alt: string = "";
    export let height: string = "auto";
    export let rounded: boolean = false;
    export let max: string = "100%";
</script>

<div class="image-wrapper">
    <img {src} {alt} style="height:{height}; border-radius: {rounded ? '1em' : 0}; --max: {max}" />
    <slot />
</div>

<style lang="scss">
    @import "./src/vars";
    .image-wrapper {
        position: relative;
    }
    img {
        width: 100%;
        object-fit: cover;
        object-position: center;
        max-width: var(--max);
    }
</style>
